export const privacyPolicyLink = "https://www.citynow.org/privacy";
export const termsOfServiceLink = "https://citynow.org/tos";
export const supportLink = "https://www.citynow.org/support";
